var exports = {
  "o1": "xaf9ae18d--df95b9--actions",
};

module.exports = exports;
